<template>
  <div id="app">
    <b-navbar toggleable="lg" type="dark" variant="primary" class="fixed-top" v-show="$route.name !== 'login' && $route.name !== 'register' && $route.name !== 'password_email' && $route.name !== 'password_reset'">
      <button @click="showCollapse = !showCollapse" :class="showCollapse ? 'collapsed' : null" aria-controls="nav_collapse" :aria-expanded="showCollapse ? 'true' : 'false'" variant="none" class="navbar-toggler">
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
        <span class="icon-bar"></span>
      </button>
      <b-navbar-brand :to="{ name: 'shippings' }"><img src="./assets/img/m.svg" alt="MOOVA" style="height: 18px"></b-navbar-brand>
      <b-form-select v-model="window.country" :options="window.countries.map(x => { return {value: x.iso_code, text: x.name} })" class="col-1 bg-primary text-white" @change="setNewCountry" v-if="isInternational">
        <template slot="first">
          <option :value="null" v-translate>All Countries</option>
        </template>
      </b-form-select>
      <b-collapse is-nav v-model="showCollapse" id="nav_collapse">
        <b-navbar-nav v-if="isAuthenticated">
          <b-nav-item-dropdown left :text="$gettext('Panels')" class="in-menu">
            <b-dropdown-item :to="{ name: 'shippingsSummary' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Summary</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'controlPanel' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Control</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'flexesControl' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>FLEXES Control</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'controlPanelCod' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>COD Control</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'incidences' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Incidences</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'incidencesBy' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Incidences By...</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'incidencesInWarehouse' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Incidences In WH</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'whEntryMonitor' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>WH Entry Monitor</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'whExitMonitor' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>WH Exit Monitor</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'whIncidencesMonitor' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>WH Incidences Monitor</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'toursControlMonitor' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Tours Control Monitor</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'pendingAccountingNotes', query: { s: JSON.stringify([['status', 'eq', 'pending']]) } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false" v-if="(isAccountApprover || isAccountant) && window.country && !$cookies.get('bypassCountry')">
              <translate>Pending Accounting Notes</translate>
            </b-dropdown-item>
            <!-- <b-dropdown-item :to="{ name: 'foodControlPanel' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>FOOD</translate>
            </b-dropdown-item> -->
          </b-nav-item-dropdown>
          <b-nav-item :to="{ name: 'map' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
            <translate>Map</translate>
          </b-nav-item>
          <b-nav-item :to="{ name: 'userList', params: { type: 'users' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
            <translate>Users</translate>
          </b-nav-item>
          <b-nav-item :to="{ name: 'courierList', params: { type: 'couriers' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
            <translate v-if="isMoova">Moovers</translate>
            <translate v-else>Couriers</translate>
          </b-nav-item>
          <b-nav-item :to="{ name: 'shippingListManual' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
            <translate>Shippings</translate>
          </b-nav-item>
          <b-nav-item :to="{ name: 'modelList', params: { type: 'item-packs' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
            <translate>Packs</translate>
          </b-nav-item>
          <b-nav-item :to="{ name: 'tourList' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
            <translate>Tours</translate>
          </b-nav-item>
          <b-nav-item :to="{ name: 'modelList', params: { type: 'companies' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
            <translate>Companies</translate>
          </b-nav-item>
          <b-nav-item :to="{ name: 'FleetRentalOrderList' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false" v-if="isMoova && (isFleet || isFleetAdmin)">
            <translate>Fleet</translate>
          </b-nav-item>
          <b-nav-item-dropdown right :text="$gettext('Accounting')" class="in-menu" v-if="isAccountant || isOperatorSupervisor">
            <b-dropdown-item :to="{ name: 'transactions' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Transactions</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'invoices' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false" v-if="isMoova && isAccountant">
              <translate>Invoices</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'erp-hooks' }, query: { s: JSON.stringify([['status', 'eq', 'pending'], ['attempts', 'gte', '1']]) } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false" v-if="isMoova && isAccountant">
              <translate>ERP Hooks</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'accounting-catalogs' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false" v-if="isMoova && isAccountant">
              <translate>Accounting Catalogs</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'fixedPriceList' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Fixed Prices</translate>
            </b-dropdown-item>
            <b-dropdown-item v-b-modal.modalFraudControl><translate>Fraud Control</translate></b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'cod-payments' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>COD Payments</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'cod-transactions' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>COD Transactions</translate>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-modal id="modalFraudControl" size="lg" ref="modalFraudControl" hide-footer>
            <div slot="modal-title" v-translate>Fraud Control</div>
            <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
            <fraud-control />
          </b-modal>
          <b-nav-item-dropdown right :text="$gettext('Configs')" class="in-menu" v-if="isAdmin">
            <div class="arrow"></div>
            <b-dropdown-item :to="{ name: 'EditBranding' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false" v-if="$eid && $eid !== '1'">
              <translate>Website Branding</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'countries' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Countries</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'regions' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Regions</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'areas' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Areas</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'postal-codes' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Postal Codes</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'warehouses' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Warehouses</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'warehouse-slots' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Warehouse Slots</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'tour-generation-bot-settings' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false" v-if="isMoova">
              <translate>Tour Generation Bot Settings</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'take-booster-configs' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false" v-if="isMoova">
              <translate>Take Booster Configs</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'quotes' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Quotes</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'services' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Services</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'quote-services' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Service Quotes</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'quote-providers' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Provider Quotes</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'outsourcing-quotes' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Outsourcing Quotes</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'outsourcing-slas' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Outsourcing SLAs</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'outsourcing-model-mappings' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Outsourcing Model Mappings</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'outsourcing-customizations' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Outsourcing Customizations</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'outsourcing-company-customizations' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Outsourcing Company Customizations</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'tags' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Tags</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'roles' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Roles</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'permissions' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false" v-if="isMoova">
              <translate>Permissions</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'mobile-apps' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Mobile Apps</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'delivery-time-ranges' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Delivery Time Ranges</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'notification-types' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Notification Types</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'shipping-types' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Shipping Types</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'event-types' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Event Types</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'receiver-types' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Receiver Types</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'vehicle-types' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Vehicle Types</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'platforms' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Platforms</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'sizes' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Sizes</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'shipping-status-reasons' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Shipping Status Reasons</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'shipping-status-reason-settings' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Shipping Status Reason Settings</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'disable-reasons' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Disable User Reasons</translate>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'applications' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false">
              <translate>Company Applications</translate>
            </b-dropdown-item>

            <b-dropdown-item :to="{ name: 'vehicleCapacityList', params: { type: 'vehicle-capacity' } }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false" v-if="isSuperAdmin">
              <translate>Vehicles Capacity</translate>
            </b-dropdown-item>

            <b-dropdown-item :to="{ name: 'b2b-doc-update' }" @click="window.innerWidth < 992 ? showCollapse = !showCollapse : false" v-if="isMoova && isSuperAdmin">
              <translate>B2B Doc Update</translate>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-nav-item-dropdown class="in-menu" right>
            <template v-slot:button-content>
              <font-awesome-icon class="no-border text-warnings" icon="tools" size="2x" style="vertical-align:middle" />
            </template>
            <b-dropdown-item v-if="isSuperAdmin || isOperatorSupervisor" :to="{ name: 'eventList' }">
              <translate>Events</translate>
            </b-dropdown-item>
            <b-dropdown-item v-if="isSuperAdmin || isOperatorSupervisor" class="no-border" v-b-modal.modalNotificationForm>
              <translate>Broadcast New Push Notification</translate>
            </b-dropdown-item>
            <b-dropdown-item v-if="isSuperAdmin || isOperatorSupervisor || isOperator || isAccountant" class="no-border" v-b-modal.modalTrackingHistory>
              <translate>Courier Tracking History</translate>
            </b-dropdown-item>
            <b-dropdown-item v-b-modal.modalInAreaCheck><translate>Address In Area?</translate></b-dropdown-item>
            <b-dropdown-item v-b-modal.modalPlaceIdCheck><translate>Place ID Checker</translate></b-dropdown-item>
            <b-dropdown-item v-b-modal.modalSearchQuotes><translate>Search for Quotes</translate></b-dropdown-item>
            <b-dropdown-item v-b-modal.modalSearchQuoteProviders><translate>Search for Provider Quotes</translate></b-dropdown-item>
            <b-dropdown-item v-b-modal.modalAreasViewer><translate>Areas Viewer</translate></b-dropdown-item>
            <b-dropdown-item v-b-modal.modalRoutingZonesViewer><translate>Routing Zones Viewer</translate></b-dropdown-item>
            <b-dropdown-item :to="{ name: 'modelList', params: { type: 'routing-zones' } }" v-if="isSuperAdmin || isAdmin || isHeadOperations" class="no-border">
              <translate>Routing Zones</translate>
            </b-dropdown-item>
            <b-dropdown-item v-b-modal.modalMenuAccountingNote><translate>Create Accounting Note</translate></b-dropdown-item>
            <b-dropdown-item v-if="isSuperAdmin || isOperatorSupervisor" :to="{ name: 'modelList', params: { type: 'announcements' } }" >
              <translate>Announcements</translate>
            </b-dropdown-item>
          </b-nav-item-dropdown>
          <b-modal id="modalInAreaCheck" ref="modalInAreaCheck" hide-footer>
            <div slot="modal-title" v-translate>Address In Area?</div>
            <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
            <in-area-check />
          </b-modal>
          <b-modal id="modalTrackingHistory" size="xl" ref="modalTrackingHistory" hide-footer>
            <div slot="modal-title" v-translate>Courier Tracking History</div>
            <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
            <tracking-history />
          </b-modal>
          <b-modal id="modalPlaceIdCheck" ref="modalPlaceIdCheck" hide-footer>
            <div slot="modal-title" v-translate>Place ID Checker</div>
            <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
            <place-id-check />
          </b-modal>
          <b-modal id="modalSearchQuotes" size="xl" ref="modalSearchQuotes" hide-footer>
            <div slot="modal-title" v-translate>Search for Quotes</div>
            <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
            <bulk-quotes-list readonly />
          </b-modal>
          <b-modal id="modalSearchQuoteProviders" size="xl" ref="modalSearchQuoteProviders" hide-footer>
            <div slot="modal-title" v-translate>Search for Provider Quotes</div>
            <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
            <bulk-quote-providers-list readonly />
          </b-modal>
          <b-modal id="modalAreasViewer" size="xl" ref="modalAreasViewer" hide-footer>
            <div slot="modal-title" v-translate>Areas Viewer</div>
            <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
            <areas-viewer />
          </b-modal>
          <b-modal id="modalRoutingZonesViewer" size="xl" ref="modalRoutingZonesViewer" hide-footer>
            <div slot="modal-title" v-translate>Routing Zones Viewer</div>
            <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
            <areas-viewer type="routing-zones" countrize-field="country_iso_code" />
          </b-modal>
          <b-modal size="lg" id="modalMenuAccountingNote" ref="modalMenuAccountingNote" hide-footer>
            <div slot="modal-title" v-translate>New Accounting Note</div>
            <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
            <accounting-note-form ref="accountingNoteForm" must-be-approved @cancel="$refs.modalMenuAccountingNote.hide()" @success="accountingNoteCreated('modalMenuAccountingNote')" />
          </b-modal>
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto" v-if="isAuthenticated">
          <b-nav-item-dropdown right>
            <div class="arrow"></div>
            <template slot="button-content">
              <b-img rounded="circle" :src="this.$store.getters.profile.profile_picture" width="32" height="32" blank-color="#777" alt="img" class="" v-if="this.$store.getters.profile.profile_picture" />
              <b-img rounded="circle" src="https://www.gravatar.com/avatar/default?s=100&r=pg&d=mm" width="32" height="32" blank-color="#777" alt="img" class="" v-else />
            </template>
            <b-dropdown-header>
              {{$store.getters.profile ? $store.getters.profile.name : ''}}<br>
              <small style="text-transform: uppercase;" v-if="$store.getters.profile && $store.getters.profile.company">{{$store.getters.profile.company.name}}</small>
            </b-dropdown-header>
            <hr class="my-2" v-if="env === 'local' || env === 'development'">
            <b-dropdown-header v-if="env === 'local' || env === 'development'" v-translate>Language Test</b-dropdown-header>
            <select name="language" v-model="$language.current" style="background: #fff; border: 0;" class="form-csontrol col-sm-12" v-if="env === 'local' || env === 'development'">
              <option v-for="(language, key) in $language.available" :value="key">{{ language }}</option>
            </select>
            <hr class="my-2">
            <b-dropdown-header>
              <b-form-checkbox v-model="filterOwnCompaniesOps" :value="true" :unchecked-value="false">
                <translate>Filter own Companies (OPS)</translate>
              </b-form-checkbox>
              <b-form-checkbox v-model="filterOwnCompaniesSls" :value="true" :unchecked-value="false" v-if="isCommercial || isHeadSales">
                <translate>Filter own Companies (SLS)</translate>
              </b-form-checkbox>
            </b-dropdown-header>
            <b-dropdown-item v-b-modal.modalSetViewAs v-if="isSuperAdmin || isOperator">
              <translate>View as...</translate>
              <b-modal size="xs" id="modalSetViewAs" ref="modalSetViewAs" hide-footer>
                <div slot="modal-title" v-translate>View as...</div>
                <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
                <label for="set-operator" v-translate>Search the user</label>
                <user-autocomplete id="set-operator" :placeholder="$gettext('Operator Name or Email')" :restrictToRoles="['operator']" @selected="setOperator" with-picture />
              </b-modal>
            </b-dropdown-item>
            <hr class="my-2">
            <b-dropdown-item :to="{ name: 'profile-edit' }">
              <font-awesome-icon icon="user" size="1x" />&nbsp;&nbsp;<translate>Profile</translate>
            </b-dropdown-item>
            <b-dropdown-item @click="forceResetCountry"><translate>Force Country</translate></b-dropdown-item>
            <b-dropdown-item v-b-modal.modalPersonalPendingAccountingNotes><translate>My Pending Accounting Notes</translate></b-dropdown-item>
            <b-dropdown-item href="#" @click.prevent="logout()">
              <font-awesome-icon icon="sign-out-alt" size="1x" />&nbsp;&nbsp;<translate>Sign out</translate>
            </b-dropdown-item>
            <b-modal id="modalPersonalPendingAccountingNotes" size="xl" ref="modalPersonalPendingAccountingNotes" hide-footer>
              <div slot="modal-title" v-translate>My Pending Accounting Notes</div>
              <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
              <api-list type="personal-pending-accounting-notes" no-actions :title="false" :pre-filters="[
                ['applied_by_id', 'eq', this.$store.getters.profile.id],
                ['status', 'eq', 'pending']
              ]" />
            </b-modal>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
      <b-navbar-nav class="ml-auto" v-if="isAuthenticated">
        <b-nav-item v-if="hasEvents" class="no-border text-warning" id="tooltip-button-1">
          <font-awesome-icon class="no-border text-warning" icon="exclamation-triangle" size="2x" style="vertical-align:middle" />
        </b-nav-item>
        <b-tooltip show target="tooltip-button-1" placement="bottomleft" v-if="hasEvents">
          <div class="text-center m-2" v-if="activeEvents.rain && activeEvents.rain.length > 0">
            <font-awesome-icon class="m-2" icon="cloud-rain" size="2x" />
            <h6 v-for="(activeEvent, i) in activeEvents.rain" :key="i">
              {{ activeEvent.area }}
            </h6>
          </div>
          <div v-else>
            <div v-for="(activeEventObj, i) in activeEvents" :key="i">
              <h6>Type "{{i}}"</h6>
              <h6 v-for="(activeEvent, n) in activeEventObj" :key="n">
                {{activeEvent.area}}
              </h6>
            </div>
          </div>
        </b-tooltip>
      </b-navbar-nav>
    </b-navbar>
    <div class="main-container">
      <router-view></router-view>
    </div><!-- /#page -->

    <b-modal id="modalNotificationForm" ref="modalNotificationForm" size="md" :hide-footer="true">
      <div slot="modal-title" v-translate>Broadcast New Push Notification</div>
      <div slot="modal-header-close"><img src="@/assets/img/ic_close.svg" alt="×" /></div>
      <broadcast-push-notification />
    </b-modal>
    <simplert :useRadius="true" :useIcon="true" ref="simplert" /><!-- notifs -->
    <div v-if="env !== 'admin-production'" id="env">{{this.env}}</div>
    <b-alert dismissible @dismissed="unsetOperator" :show="!!filterByOperator.name" variant="warning" class="text-right" style="position: fixed; top: 50px; right: 0">
      <span>
        <div class="float-left mr-2">
          <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" class="rounded-circle" alt="img" :style="'display: inline-block; width: 25px; height: 25px; background: url(' + (filterByOperator.profile_picture || 'https://www.gravatar.com/avatar/default?s=25&r=pg&d=mm') + ') transparent no-repeat 50% 50%/cover;'" />
        </div>
        <span style="line-height: 25px">
          <translate>Viewing as</translate>
          <strong><router-link :to="{ name: 'viewUser', params: { id: filterByOperator.id } }" target="_blank" class="alert-warning">{{filterByOperator.name}}</router-link></strong>
        </span>
      </span>
    </b-alert>
  </div>
</template>
<script>
import BroadcastPushNotification from '@/components/BroadcastPushNotification'
import simplert from 'vue2-simplert'
import InAreaCheck from '@/components/InAreaCheck'
import TrackingHistory from '@/components/TrackingHistory'
import PlaceIdCheck from '@/components/PlaceIdCheck'
import BulkQuotesList from '@/components/BulkQuotesList'
import BulkQuoteProvidersList from '@/components/BulkQuoteProvidersList'
import FraudControl from '@/components/FraudControl'
import UserAutocomplete from '@/components/autocompletes/UserAutocomplete'
import AreasViewer from '@/components/AreasViewer'
import AccountingNoteForm from '@/components/AccountingNoteForm'
import ApiList from '@/components/ApiList'

export default {
  name: 'App',
  components: {
    BroadcastPushNotification,
    simplert,
    InAreaCheck,
    TrackingHistory,
    PlaceIdCheck,
    BulkQuotesList,
    BulkQuoteProvidersList,
    FraudControl,
    UserAutocomplete,
    AreasViewer,
    AccountingNoteForm,
    ApiList
  },
  data() {
    return {
      env: process.env.ENV_FLAG,
      showCollapse: false,
      window: window,
      currentFrontVersion: null,
      availableFrontVersion: null,
      updateNotice: false,
      intervalCheckFrontVersionInterval: 5 * 60 * 1000,
      intervalCheckFrontVersion: null,
      hasEvents: false,
      activeEvents: {},
      filterOwnCompaniesOps: false,
      filterOwnCompaniesSls: false,
      filterByOperator: {},
      avoom: false
    }
  },
  watch: {
    filterOwnCompaniesOps(val) {
      this.$cookies.set('filterOwnCompanies', val)
      if (val === true) {
        this.$cookies.remove('impersonating')
        this.filterByOperator = {}
      }
    },
    filterOwnCompaniesSls(val) {
      this.$cookies.set('filterOwnCompaniesSls', val)
    }
  },
  mounted() {
    // i18n setup
    const availableLanguages = Object.keys(this.$language.available)
    this.$language.current = availableLanguages.indexOf(window.navigator.language.substring(0, 2)) !== -1 ? window.navigator.language.substring(0, 2) : 'en' // this.$frontConfig.i18n.lang || 'en_US'
    let moment = this.$frontConfig.i18n.moment || 'en'
    this.moment.locale(moment)
    this.moment.tz.setDefault(this.$tz)

    this.getActiveEvents()
    this.checkFrontVersion()
    this.intervalCheckFrontVersion = setInterval(function () {
      this.checkFrontVersion()
      this.getActiveEvents()
    }.bind(this), this.intervalCheckFrontVersionInterval)

    // Dynamic favicon
    let link = document.querySelector("link[rel*='icon']") || document.createElement('link')
    link.type = 'image/png'
    link.rel = 'shortcut icon'
    link.href = '/static/img/backoffice-icon' + (process.env.NODE_ENV !== 'production' ? '-development' : '') + '.png'
    document.getElementsByTagName('head')[0].appendChild(link)

    this.filterOwnCompaniesOps = this.$cookies.get('filterOwnCompanies')
    this.filterOwnCompaniesSls = this.$cookies.get('filterOwnCompaniesSls')
    this.filterByOperator = this.$cookies.get('impersonating') || {}

    // million not easter egg anymore :(
    if (!this.$cookies.get('millionSeen')) {
      // turned off
      this.avoom = false
    }

    // if there were errors geolocating user, force country to user's company country or user country
    if (this.$cookies.get('countryFailure') && this.$cookies.get('countryFailure') === 'true') {
      this.forceResetCountry()
    }
  },
  beforeDestroy() {
    clearInterval(this.intervalCheckFrontVersion)
  },
  methods: {
    checkFrontVersion() {
      this.$http.get('/static/version.json')
        .then(response => {
          this.availableFrontVersion = response.body.version
          if (this.currentFrontVersion === null) {
            this.currentFrontVersion = this.availableFrontVersion
          } else if (this.currentFrontVersion !== this.availableFrontVersion) {
            const h = this.$createElement
            const mssg = h(
              'p',
              { class: ['text-left', 'mb-0'] },
              [
                this.$gettext('There is a new version of the Backoffice, please reload all currently opened windows/tab to get the new version with the latest changes.'),
                h('br', {}, ''),
                h('br', {}, ''),
                this.$gettext('Current version: '),
                h('em', {}, this.currentFrontVersion),
                h('br', {}, ''),
                this.$gettext('Available version: '),
                h('strong', {}, this.availableFrontVersion)
              ]
            )
            if (this.updateNotice === false) {
              this.makeToast(this.$gettext('Notice'), mssg, 'info')
              this.updateNotice = true
            }
          }
        })
    },
    setNewCountry() {
      this.$cookies.remove('warehouse')
      if (this.window.country === null) {
        this.$cookies.set('bypassCountry', 'true', 60 * 60 * 24 * 30, '/', null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$cookies.set('countryForced', 'true', 60 * 60 * 24 * 30, '/', null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
      } else {
        this.$cookies.remove('bypassCountry')
        this.$frontConfig = window.countries.find(x => x.iso_code === this.window.country).front_config || null
        this.$cookies.set('country', this.window.country, 60 * 60 * 24 * 30, '/', null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$cookies.set('phonePrefix', this.$frontConfig.i18n.phonePrefix, 60 * 60 * 24 * 30, '/', null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$cookies.set('countryForced', 'true', 60 * 60 * 24 * 30, '/', null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$emit('countryChanged')
      }
      window.location.reload()
    },
    forceResetCountry() {
      if (this.$store.getters.profile.id) {
        let forcedCountryIsoCode = this.$store.getters.profile.company ? this.$store.getters.profile.company.country_iso_code : this.$store.getters.profile.country_iso_code
        this.$cookies.remove('bypassCountry')
        this.$cookies.remove('countryFailure')
        this.$frontConfig = forcedCountryIsoCode ? window.countries.find(x => x.iso_code === forcedCountryIsoCode).front_config : this.$frontConfig
        this.$frontConfig.i18n.tz = this.$tz = this.$cookies.get('bypassCountry') || !this.$frontConfig.i18n.tz ? 'UTC' : this.$frontConfig.i18n.tz
        this.$cookies.set('country', forcedCountryIsoCode, 60 * 60 * 24 * 30, '/', null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$cookies.set('phonePrefix', this.$frontConfig.i18n.phonePrefix, 60 * 60 * 24 * 30, '/', null, (process.env.COOKIE_SECURE !== '' || false), process.env.COOKIE_SAME_SITE)
        this.$emit('countryChanged')
        window.location.reload()
      } else {
        setTimeout(this.forceResetCountry, 100)
      }
    },
    getActiveEvents() {
      let params = {
        includes: ['area', 'event_type'],
        filter_groups: [
          {
            filters: [
              ['active', 'eq', 1],
              ['from_date', 'lte', this.moment.utc().format('YYYY-MM-DD HH:mm:ss')],
              ['to_date', 'gte', this.moment.utc().format('YYYY-MM-DD HH:mm:ss')]
            ]
          }
        ]
      }
      if (!this.$cookies.get('bypassCountry')) {
        params.filter_groups.push(
          {
            filters: [
              ['area.country', 'eq', this.window.country]
            ]
          }
        )
      }
      this.$http.get(this.$appConfig.api.baseUrl + 'events', { params: params })
        .then(response => {
          this.hasEvents = response.body.data.length > 0
          this.activeEvents = {}
          response.body.data.forEach((item, i) => {
            if (typeof this.activeEvents[item.event_type.name] === 'undefined') {
              this.activeEvents[item.event_type.name] = []
            }
            this.activeEvents[item.event_type.name].push({...item, area: item.area.name})
          })
        })
    },
    setOperator(user) {
      this.filterByOperator = {
        id: user.id,
        name: user.name,
        email: user.email,
        profile_picture: user.profile_picture
      }
      this.$cookies.set('filterOwnCompanies', false)
      this.$cookies.set('impersonating', this.filterByOperator)
      window.location.reload()
    },
    unsetOperator() {
      this.filterByOperator = {}
      this.$cookies.remove('impersonating')
      window.location.reload()
    }
  }
}

</script>
<style lang="scss">
@import 'assets/scss/app.scss';

body {
  background: #fff !important
}

#app {
  padding-top: 65px
}

.page-header {
  height: auto !important;
}

.simplert {
  z-index: 1060 !important;
}

#env {
  position: fixed;
  top: 0;
  left: 0;
  background: #000;
  color: #fff;
  padding: 2px 5px;
  z-index: 10000
}
.in-menu .dropdown-toggle {
  line-height: 40px !important;
}

// 2FA PINcode
div.vue-pincode-input-wrapper {
  font-size: 1.6rem;
}
input.vue-pincode-input {
  box-shadow: 0 0 15px rgba(0,0,0,.1);
  max-width: 3rem !important;
  margin: .25rem !important;
  background: #fff;
  border: 1px solid #ddd;
  transition: all .25s ease-in-out;
  &:focus {
    border: 1px solid #ccc;
    box-shadow: 0 0 5px rgba(0,0,0,.25);
  }
}

.dropdown-menu {
  overflow-y: auto;
  max-height: calc(100vh - 50px);
}

</style>
